import React from 'react';
import { Box, styled } from '@mui/material';

const StyledBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    gap: '20px',
    paddingBottom: '20px',
    [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
    },
}));

export const QuotationFormRowWrapper: React.FC<{
    children: React.ReactNode;
}> = (props) => {
    return <StyledBox>{props.children}</StyledBox>;
};
